
<template>
  <v-app class="bg">
    <router-view v-if="valid_session"></router-view>
  </v-app>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'ClientOrderHome',
  data() {
    return {
    }
  },
  methods: {
    orderToken() {
      return this.$route.query.tk || sessionStorage.getItem('order_token')
    },
    handleQuery() {
      const tk = this.orderToken()
      if (tk) {
        this.validateSession(tk)
      }
    },
    goToOrderHome(tk) {
      const target = {
        path: '/client_order_details/home',
        query: { tk }
      }
      const alreadyThere =
        this.$route.path === target.path && this.$route.query.tk === tk

      if (!alreadyThere) {
        this.$router.replace(target)
      }
    },
    ...mapActions({
      validateSession: 'ClientOrder/validateSession'
    })
  },
  computed: {
    ...mapState({
      valid_session: state=> state.ClientOrder.valid
    })
  },
  mounted () {
    this.handleQuery();
  },
  watch: {
    valid_session(nv) {
      if (nv) {
        const tk = this.orderToken()
        if (tk) {
          this.goToOrderHome(tk)
        }
      }
    }
  },
}
</script>

<style scoped>
  .bg{
    background-color: #EEEEEE !important;
  }
  .v-application .red.darken-3 {
    background-color: #EEEEEE !important;
  }
</style>

